import React from 'react';
import PropTypes from 'prop-types';

import Quote from 'models/quote';

import PackageEvents from 'containers/checkout/parking-details/package-events';

const propTypes = {
  quote: PropTypes.instanceOf(Quote).isRequired,
};


const EventPackageEvents = ({ quote }) => {
  if (!quote.packagePricings || !quote.isEventPackage) { return null; }
  return <div className="hidden-xs"><PackageEvents events={quote.packagePricings} /></div>;
};

EventPackageEvents.propTypes = propTypes;
export default EventPackageEvents;
